var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParkActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "#6A8860"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#6A8860"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4316_70960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8039 8.64804C24.2599 8.64804 22.1959 10.712 22.1959 13.256V17.276C22.1959 19.496 23.7799 21.356 25.8679 21.788V26.96H24.0559V22.976H10.4479V26.96H8.58789V28.82H10.4479V31.364H12.3079V28.82H22.2079V31.364H24.0679V28.82H25.8799V31.364H27.7399V21.788C29.8279 21.356 31.4119 19.496 31.4119 17.276V13.244C31.4119 10.712 29.3479 8.64804 26.8039 8.64804ZM12.3079 24.836H22.2079V26.948H12.3079V24.836ZM29.5519 17.276C29.5519 18.464 28.7959 19.472 27.7399 19.856V14.336H25.8799V19.844C24.8239 19.46 24.0679 18.452 24.0679 17.264V13.244C24.0679 11.732 25.2919 10.508 26.8039 10.508C28.3159 10.508 29.5399 11.732 29.5399 13.244V17.276H29.5519Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4316_70960"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkActive);
export default __webpack_public_path__ + "static/media/parkActive.735872a09799ee843dfa54cca2d042cf.svg";
export { ForwardRef as ReactComponent };